import { render } from "./YellowConsultantTable.vue?vue&type=template&id=7ed5b187"
import script from "./YellowConsultantTable.vue?vue&type=script&lang=js"
export * from "./YellowConsultantTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__